import { render, staticRenderFns } from "./BrandsSidebarItem.vue?vue&type=template&id=0b529c66"
import script from "./BrandsSidebarItem.vue?vue&type=script&lang=js"
export * from "./BrandsSidebarItem.vue?vue&type=script&lang=js"
import style0 from "./BrandsSidebarItem.vue?vue&type=style&index=0&id=0b529c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports